import { app } from '../../../../../app';
import { Controller } from './integrate-usb-token.controller';

app.component('integrateUsbToken', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./integrate-usb-token.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/integrate-usb-token/integrate-usb-token.component.js